import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import ArchiveConfirmDialog from "./ArchiveConfirmDialog";
import { useSnackbar } from "notistack";
import { archiveApplications } from "apis/controllers/clearings";

const TerminationSummaryTable = ({ rows = [], onOpenDialog, seasonId = 2025 }) => {
    const { enqueueSnackbar } = useSnackbar()

    const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
    const [confirming, setConfirming] = useState(false)
    const [selectedRow, setSelectedRow] = useState(false);

    const handleArchive = async () => {
        setConfirming(true)
        try {
            const res = await archiveApplications({ seasonId, typeId: selectedRow?.typeId });

            if (res.status === "success") {
                enqueueSnackbar(res.message || 'Οι αιτήσεις τέθηκαν επιτυχώς στο αρχείο!', { variant: "success" });
                // optionally trigger parent refresh or update rows here
            } else {
                enqueueSnackbar(res.message || "Προέκυψε σφάλμα κατα την αρχειοθέτηση των αιτήσεων!", { variant: "error" });
            }
        }
        catch (e) {
            console.log(e)
        }

        finally {
            setOpenArchiveDialog(false);
            setConfirming(false)
        }

    };

    const onOpenArchive = (row) => {
        setOpenArchiveDialog(true)
        setSelectedRow(row)
    }


    return (
        <Box
            sx={{
                border: "1px solid #dcdcdc",
                borderRadius: 1.5,
                width: "100%",
                overflowX: "auto", // ✅ full scroll freedom
                mt: 1,
            }}
        >
            {/* use table layout for stable, scrollable structure */}
            <Box sx={{ display: "table", width: "100%", minWidth: 700 }}>
                {/* Header */}
                <Box
                    sx={{
                        display: "table-row",
                        backgroundColor: (theme) => theme.palette.action.hover,
                        borderBottom: "1px solid",
                        borderColor: (theme) => theme.palette.divider,
                    }}
                >
                    {[
                        "Τύπος Αίτησης",
                        "Υποβληθείσες",
                        "Εγκεκριμένες",
                        "Απορριφθείσες",
                        "Κατάσταση Ελέγχου",
                        "Ενέργειες",
                    ].map((header, idx) => (
                        <Box
                            key={idx}
                            sx={{
                                display: "table-cell",
                                fontWeight: 600,
                                px: 1,
                                py: 1,
                                textAlign: idx === 0 ? "left" : idx === 5 ? "center" : "right",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {header}
                        </Box>
                    ))}
                </Box>

                {/* Rows */}
                {rows.map((row, idx) => (
                    <Box
                        key={row.typeId}
                        sx={{
                            display: "table-row",
                            // classic alternating row colors using theme
                            backgroundColor: (theme) => (idx % 2 === 0 ? theme.palette.background.paper : theme.palette.action.hover),
                            borderBottom: idx < rows.length - 1 ? "1px solid" : "none",
                            borderColor: (theme) => theme.palette.divider,
                        }}
                    >
                        {/* Τύπος Αίτησης */}
                        <Box
                            sx={{
                                display: "table-cell",
                                px: 1,
                                py: 1.2,
                                textAlign: "left",
                                fontWeight: 600,
                                color: "primary.main",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {row.type}
                        </Box>

                        {/* Υποβληθείσες */}
                        <Box
                            sx={{
                                display: "table-cell",
                                px: 1,
                                py: 1.2,
                                textAlign: "right",
                                fontWeight: 600,
                            }}
                        >
                            {row.submitted}
                        </Box>

                        {/* Εγκεκριμένες */}
                        <Box
                            sx={{
                                display: "table-cell",
                                px: 1,
                                py: 1.2,
                                textAlign: "right",
                                fontWeight: 600,
                            }}
                        >
                            {row.approved}
                        </Box>

                        {/* Απορριφθείσες */}
                        <Box
                            sx={{
                                display: "table-cell",
                                px: 1,
                                py: 1.2,
                                textAlign: "right",
                                fontWeight: 600,
                            }}
                        >
                            {row.rejected}
                        </Box>

                        {/* Κατάσταση Ελέγχου */}
                        <Box
                            sx={{
                                display: "table-cell",
                                px: 1,
                                py: 1.2,
                                textAlign: "right",
                                fontWeight: 600,

                                whiteSpace: "nowrap",

                            }}
                            className={row?.css}
                        >
                            {row.status}
                        </Box>

                        {/* Ενέργεια */}
                        <Box
                            sx={{
                                display: "table-cell",
                                px: 1,
                                py: 1.2,
                                textAlign: "right",
                            }}
                        >
                            <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                                <Button
                                    variant="contained"
                                    color="error"
                                    size="small"
                                    onClick={() => onOpenDialog(row)}
                                    disabled={!row?.canCloseChecks}
                                    sx={{ fontWeight: 600, borderRadius: 2, whiteSpace: "nowrap" }}
                                >
                                    Ολοκλήρωση
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={() => onOpenArchive(row)}
                                    disabled={!row?.canArchive}
                                    sx={{ color: '#fefefe', fontWeight: 600, borderRadius: 2, whiteSpace: "nowrap" }}
                                >
                                    Αρχειοθέτηση
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
            <ArchiveConfirmDialog open={openArchiveDialog} onClose={() => setOpenArchiveDialog(false)} onUpdate={handleArchive} confirming={confirming} />
        </Box >
    );
};

export default TerminationSummaryTable;
